export default __webpack_public_path__ + "static/media/1128040325512734.b7ccc44e.jpg";